import {AfterViewInit, Component, Inject, OnInit} from '@angular/core';
import {User} from "../../../shared/interface/user";
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {UserService} from "../../../shared/services/user.service";
import {takeUntil, tap} from "rxjs/operators";
import {CountedAndPaginated} from "../../../shared/interface/response/counted-and-paginated";
import {ReplaySubject} from "rxjs";
import {HttpErrorResponse} from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialogRef} from "@angular/material/dialog";
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {RiskConfiguration} from "../../../shared/interface/risk-configuration";
import {ex} from "@fullcalendar/core/internal-common";

@Component({
  selector: 'app-add-email-to-form-dialog',
  templateUrl: './add-email-to-form-dialog.component.html',
  styleUrls: ['./add-email-to-form-dialog.component.scss']
})
export class AddEmailToFormDialogComponent implements OnInit, AfterViewInit {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  activeStateOfArray: any[];
  initialFilters: any;
  totalData = 0;
  emailDialogForm: FormGroup;
  users: User[] = [];
  user?: User;
  userControl: FormControl;
  userEmailControl: FormControl;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddEmailToFormDialogComponent>,
    private userService: UserService,
    private fb: FormBuilder,
    private snack: MatSnackBar,
  ) {
    this.activeStateOfArray = data.activeStateOfArray;
    this.emailDialogForm = this.fb.group({
      email: this.userEmailControl = this.fb.control('', [Validators.required, Validators.email]),
      user: this.userControl = this.fb.control('', []),
    });
  }

  ngAfterViewInit(): void {
    if(this.userControl){
    this.userControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((val: string) => {
        this.userService.get(val).subscribe((user: User) => {
          this.userEmailControl.setValue(user.email);
        }, (error: HttpErrorResponse) => {
          this.userEmailControl.reset();
        });
      });
  }}

  ngOnInit(): void {}

  userChanged(user: User): void {
    this.user = user;
  }
  addMail(): void {
    const emailValue = this.userEmailControl.value;
    const emailFormArray = this.data.activeStateOfArray;
    if (this.emailDialogForm.valid) {
      const emailFormGroup = this.fb.group({
        emailAddressList: [emailValue, [Validators.required, Validators.email]]
      });
      if (emailFormArray.length > 0) {
        const exists = emailFormArray.some(formGroup => formGroup.value.emailAddressList === emailFormGroup.value.emailAddressList);
          if (!exists) {
            emailFormArray.push(emailFormGroup);
            this.dialogRef.close(emailFormArray);
          }
          else {
            this.snack.open('Adres został juz dodany', '', {
              duration: 2000
            });
          }
      } else {
        emailFormArray.push(emailFormGroup);
        this.dialogRef.close(emailFormArray);
      }
    }
    else{
      this.snack.open('Wprowadź prawidłowy adres mailowy', '', {
        duration: 2000
      });
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
